import isString from 'lodash/isString';
import { NET_RATE_FIXED_OPTION_NAME } from '../models/RatePart';
import { rateFormatterInstance } from './RateFormatter';

export const MultipleRateFormatter = ({ value, data, context }) => {
    const datasetId = data?.datasetId;
    const rateFormat = context?.rateFormat;
    if (!value || !value.rateParts || value.rateParts.length === 0) {
        return '';
    }

    if (isString(value)) {
        //formatted already
        return value;
    }

    const text = [];

    if (value.hasOwnProperty('partType')) {
        text.push(rateFormatterInstance.format(value, datasetId, rateFormat));
    } else {
        if (value.isNetRate) text.push(NET_RATE_FIXED_OPTION_NAME);

        value.rateParts.forEach((part) => {
            text.push(
                rateFormatterInstance.format(part, datasetId, rateFormat)
            );
        });
    }

    return text.join(' ');
};
